import { render } from "./Winners.vue?vue&type=template&id=7b6c3624"
import script from "./Winners.vue?vue&type=script&lang=js"
export * from "./Winners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__